import logger from '@utils/logger';
import { useCreateSubcategoryMutation } from 'src/graphql/generated/graphql';

const useCreateSubcategory = () => {
  const { mutate, mutateAsync, isError, isLoading, isSuccess, data } = useCreateSubcategoryMutation({
    onError: (error) => {
      let loggedError: Error = Error('createSubcategory failed');
      if (error instanceof Error) {
        loggedError = error;
      }
      void logger.error('Call to createSubcategory resulted in error', loggedError);
    },
    onSuccess: (response) => {
      const { error } = response.createSubcategory;
      if (error) {
        void logger.error('Call to createSubcategory resulted in error', error);
      } else {
        void logger.info('Successfully created subcategory');
      }
    },
  });

  const { error } = data?.createSubcategory ?? {};
  return {
    mutate,
    mutateAsync,
    isError,
    isLoading,
    isSuccess,
    error,
    data: data?.createSubcategory.subcategory,
  };
};

export default useCreateSubcategory;
